import treasury from '../api/team-treasury.api'
import store from './index'
// root state object.
// each Vuex instance is just a single state tree.
const state = {
  teamExpenses: []
}

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  refreshTeamExpenses (state, expenses) {
    state.teamExpenses = expenses
  }
}

// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  getExpensesForTeam (context, teamId) {
    treasury.api.getTeamExpenses(teamId)
      .then(response => {
        context.commit('refreshTeamExpenses', response.data)
      },
      error => {
        console.log('impossible to load expenses from api: ')
        console.log(error)
      })
  },
  purgeTeamExpenses (context) {
    context.commit('refreshTeamExpenses', null)
  }
}

// getters are functions
const getters = {
  teamExpenses: state => {
    return state.teamExpenses
  },
  isStarSalaryPaid: (state, getters) => (leagueId) => {
    // on suppose que si on arrive dans ce getters, on sait que l'équipe passé en paramètre a un star player
    // on choppe toutes les journées de l'équipe en paramètre
    // on choppe le libellé de la dernière journée
    // on regarde si il existe une dépense de type STARPPLAYER_SALARY dont le libellé correspond à la dernière journée
    if (store.getters.lastWeekListForLeague(leagueId) && state.teamExpenses) {
      let weekTitle = store.getters.lastWeekListForLeague(leagueId).title
      let found = state.teamExpenses.findIndex(expense => {
        return weekTitle === expense.report
      })
      if (found !== -1) {
        return true
      }
      return false
    }
    return null
  },
  hasStadium: state => {
    if (state.teamExpenses === null) {
      return null
    }
    let found = state.teamExpenses.findIndex(expense => {
      return expense.type !== null && expense.type.key === 'STADIUM'
    })
    if (found !== -1) {
      return true
    }
    return false
  },
  missingMoneyForStadium: state => {
    if (state.teamExpenses === null) {
      return 250
    }
    let savedMoneyExpList = state.teamExpenses.filter(expense => {
      return expense.type !== null && expense.type.key === 'SM_FOR_STADIUM'
    })
    let savedMoney = savedMoneyExpList.length
    return 250 - savedMoney * 50
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/team-treasury.js